export default "__VITE_ASSET__D0qNsBJD__"